<template>
    <el-dialog
        v-model="dialogShow"
        :title="title"
        :width="width" 
        :top="top"
        :before-close="handleClose"
        destroy-on-close
        >
        <div>
            <div class="block">
                <div class="hint">{{hint}}</div>
                <div class="dv-back">
                    {{ message }}
                </div>
            </div>
            <ConfirmButton class="mmp" @buttonClick="selectButton" :space="30"></ConfirmButton>
        </div>
    </el-dialog>
  </template>
  
  <script>
  import ConfirmButton from '../ConfirmButton.vue'
  export default {
    name: 'ConfirmDialog',
    components:{
        ConfirmButton
    },
    props: {
      showDialog:Boolean,
      title:{
        type:String,
        default:"输入"
      },
      message:{
        type:String,
        default:"请输入内容"
      },
      width:{
        type:String,
        default:"470px"
      },
      top:{
        type:String,
        default:"150px"
      }
    },
    watch:{
        showDialog:function(nval,old){
            this.dialogShow = nval
        }
    },
    data(){
        return {
            dialogShow:this.showDialog
        }
    },
    methods:{
        ///选择按钮
        selectButton:function(result){
           
            this.$emit("selectButton",result)
        },
        handleClose:function(){
          this.selectButton(false)
        }
    }
  }
  </script>
  
  <!-- Add "scoped" attribute to limit CSS to this component only -->
  <style scoped>
  .mmp{
    margin-top: 50px;
    margin-bottom: 20px;
  }
  .block{
    padding-left: 30px;
    padding-right: 30px;
    margin-bottom: 30px;
    margin-top: 10px;
  }
  .input{
    width: 100%;
    border: none;
    outline: none;
    height: 35px;
  }
  .dv-back{
    border-radius: 5px;
    margin-top: 20px;
    margin-bottom: 20px;
    text-align: center;
    line-height: 130px;
    color: var(--ek-text-color1);
    font-size: 15px;
  }
  .hint{
    color:var(--ek-text-color2);
  }
  </style>
  